import { Host, h } from '@stencil/core';
export class AibaQuantitySelector {
  constructor() {
    /*istanbul ignore next*/
    this.handleIncrement = (e) => {
      var _a;
      if (this.quantity < this.max) {
        this.quantity += 1;
        (_a = this.handlers) === null || _a === void 0 ? void 0 : _a.handleIncrementHandler(e);
        this.error = false;
        this.cartError = false;
      }
      else {
        this.error = true;
        this.cartError = false;
      }
    };
    this.handleDecrement = (e) => {
      var _a;
      if (this.quantity > this.min) {
        this.quantity -= 1;
        (_a = this.handlers) === null || _a === void 0 ? void 0 : _a.handleDecrementHandler(e);
        this.error = false;
        this.cartError = false;
      }
      else {
        this.quantity = 1;
        this.cartError = false;
      }
    };
    this.data = undefined;
    this.handlers = undefined;
    this.max = 10;
    this.min = 1;
    this.outOfStock = false;
    this.quantity = 1;
    this.error = false;
    this.cartError = false;
    this.cartErrorMessage = 'Cart Error: You Have Reached Limit';
  }
  /*istanbul ignore next*/
  componentDidUpdate() {
    var _a;
    const span = (_a = document.querySelector('aiba-app')) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector('aiba-quantity-selector').querySelector('span');
    const spanText = span === null || span === void 0 ? void 0 : span.innerText;
    console.log(spanText);
    span.innerHTML = `${this.quantity}`;
    console.log(spanText);
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return (h(Host, null, h("div", { class: "quantity-selector" }, ((_a = this.data) === null || _a === void 0 ? void 0 : _a.decrementButton) && h("aiba-button", Object.assign({}, (_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.decrementButton) === null || _c === void 0 ? void 0 : _c.data, { handleClick: this.handleDecrement })), h("span", null, this.quantity), ((_d = this.data) === null || _d === void 0 ? void 0 : _d.incrementButton) && h("aiba-button", Object.assign({}, (_f = (_e = this.data) === null || _e === void 0 ? void 0 : _e.incrementButton) === null || _f === void 0 ? void 0 : _f.data, { handleClick: this.handleIncrement }))), this.error && (h("div", { class: "quantity-error" }, (_j = (_h = (_g = this.data) === null || _g === void 0 ? void 0 : _g.error) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.elements.map((element) => {
      if (element.name === 'aiba-label') {
        return h("aiba-label", Object.assign({}, element['data']));
      }
    }))), this.cartError && (h("div", { class: "cart-error" }, h("aiba-label", { tag: "p", text: this.cartErrorMessage })))));
  }
  static get is() { return "aiba-quantity-selector"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-quantity-selector.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-quantity-selector.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "max": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "max",
        "reflect": false,
        "defaultValue": "10"
      },
      "min": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "min",
        "reflect": false,
        "defaultValue": "1"
      },
      "outOfStock": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "out-of-stock",
        "reflect": false,
        "defaultValue": "false"
      },
      "quantity": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "quantity",
        "reflect": false,
        "defaultValue": "1"
      },
      "error": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "error",
        "reflect": false,
        "defaultValue": "false"
      },
      "cartError": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "cart-error",
        "reflect": false,
        "defaultValue": "false"
      },
      "cartErrorMessage": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "cart-error-message",
        "reflect": false,
        "defaultValue": "'Cart Error: You Have Reached Limit'"
      }
    };
  }
}
//# sourceMappingURL=aiba-quantity-selector.js.map
